function n(n,t){const e=n.find((n=>!0===n[0]()));return e?e[1]():t()}function t(n,t,e){return n.map((n=>n())).indexOf(!0)>-1||!(t.map((n=>n())).indexOf(!0)>-1)&&e}export{t as anyPassOrAnyFail,n as returnOrFallthrough};
